import * as scssStyles from '../../../css/settings.scss';
import styled from '@emotion/styled';
import { Button, Radio, DialogTitle, DialogActions, DialogContent } from '../../../MaterialUIComponents';

const GeotabStyledDialogTitle = `
    padding-bottom: 0px;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 24px;
    display: flex;
    align-items: center;
`;

const EncompassStyledDialogTitle = `
    padding: 16px;
    display: flex;
    align-items: center;
    font-size: 18px; 
    font-weight: 400; 
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
`;

const GeotabStyledActions = `
    margin: 15px 30px 30px 30px;
    padding: 0;
    justify-content: space-between;    
`;
const GeotabStyledConfirmActions = `
    padding: 8px 24px;
    background-color: #f9fafb;
    border-top: 1px solid #dde2eb;
`;

const EncompassStyledActions = `
    margin: 5px 0 5px 0;
    padding: 15px 17px 16px 0;
    justify-content: flex-end;
    box-shadow: 0px -3px 8px rgba(0, 0, 0, 0.15);
`;

const GeotabStyledButton = `
    width: 45%;
`;

const EncompassStyledDialogContent = `
    padding: 24px 16px !important;
    font-weight: 400;
    font-family: ${scssStyles.fontFamily};
    font-size: 18px;
`;

const GeotabStyledDialogContent = `
    padding-top: 16px !important;
    padding-right: 24px !important;
    padding-bottom: 24px !important;
    padding-left: 24px !important;
    font-weight: ${scssStyles.fontWeight};
    font-family: ${scssStyles.fontFamily};
    font-size: 20px;
`;

const GeotabStyledPlainButton = `
    width: auto !important;
    padding: 12px;
`;
const GeotabStyledPlainCancelButton = `${GeotabStyledPlainButton}
    border: 0px solid;
    &:hover {
        border: 0px solid !important;
        background-color: transparent !important;
        color: #223E6E;
    }
`;

const EncompassStyledPlainButton = `
    padding: 10px 15px 10px 15px;
    &:hover {
         padding: 10px 15px 10px 15px;
    }
    min-width: 85px;
    height: 36px;
    font-size: 16px;
`;

const EncompassStyledButton = `
    padding: 10px 15px 10px 15px;
    font-size: 16px;
`;
const StyledDialogTitle = styled(DialogTitle)`
    ${() => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledDialogTitle;
            case 'encompass':
                return EncompassStyledDialogTitle;
            default:
                return GeotabStyledDialogTitle;
        }
    }};

    & > h2 {
        font-size: 20px;
        font-weight: bold;
    }
`;
const StyledDialogContent = styled(DialogContent)`
    ${() => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledDialogContent;
            case 'encompass':
                return EncompassStyledDialogContent;
            default:
                return GeotabStyledDialogContent;
        }
    }};
`;

const StyledDialogActions = styled(DialogActions)`
    ${() => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledActions;
            case 'encompass':
                return EncompassStyledActions;
            default:
                return GeotabStyledActions;
        }
    }};
`;

const StyledConfirmDialogActions = styled(DialogActions)`
    ${() => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledConfirmActions;
            case 'encompass':
                return EncompassStyledActions;
            default:
                return GeotabStyledActions;
        }
    }};
`;

const StyledBaseButton = styled(Button)`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 20px;
    gap: 10px;
    line-height: 15px;
    font-size: 13px;
    font-weight: ${scssStyles.fontWeight};
    font-family: ${scssStyles.fontFamily};
`;
const StyledScoreButton = styled(StyledBaseButton)`
    background-color: ${scssStyles.buttonSubmitBackground};
    color: white;
    margin-right: 16px;
    &:hover {
        background-color: ${scssStyles.buttonHover};
    }
`;

const StyledSubmitButton = styled(StyledBaseButton)`
    ${() => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledButton;
            case 'encompass':
                return EncompassStyledButton;
            default:
                return GeotabStyledButton;
        }
    }};
    background-color: ${scssStyles.buttonSubmitBackground};
    color: white;
    border: 1px solid ${scssStyles.buttonSubmitBackground};
    &:disabled {
        border: 1px solid #989898;
        color: ${scssStyles.styleEnvironment == 'geotab' ? '#989898' : 'white'};
        border-radius: ${scssStyles.styleEnvironment == 'geotab' ? '$border-radius-filter-button' : '3px'};
        background-color: ${scssStyles.styleEnvironment == 'geotab' ? 'white' : '#878B8C'};
    }
    &:hover {
        background-color: ${scssStyles.buttonHover};
        border: 1px solid ${scssStyles.buttonHover};
    }
`;

const StyledCancelButton = styled(StyledBaseButton)`
    ${() => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledButton;
            case 'encompass':
                return EncompassStyledButton;
            default:
                return GeotabStyledButton;
        }
    }};
    color: ${scssStyles.buttonCancelBackground};
    border: 1px solid ${scssStyles.buttonCancelBackground};
`;

const StyledRadio = styled(Radio)`
    color: ${scssStyles.radioButton};
    &.Mui-checked {
        color: ${scssStyles.radioButtonChecked};
    }
    &.Mui-checked ~ span {
        font-weight: ${scssStyles.fontWeight};
    }
`;

const StyledPlainSubmitButton = styled(StyledSubmitButton)`
    ${() => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledPlainButton;
            case 'encompass':
                return EncompassStyledPlainButton;
            default:
                return GeotabStyledPlainButton;
        }
    }};
    text-transform: capitalize;
`;

const StyledPlainCancelButton = styled(StyledCancelButton)`
    ${() => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledPlainCancelButton;
            case 'encompass':
                return EncompassStyledButton;
            default:
                return GeotabStyledPlainCancelButton;
        }
    }};
    text-transform: capitalize;
`;

const EncompassStyledBulkAssignButton = `
    padding: 12px 12px 8px 12px;
    border: 1px solid #0078d3;
    border-bottom: 5px solid #0b68a7;
    color: #ffffff;
    line-height: 16px;
    &:hover{
        border-bottom: 5px solid #0b68a7;
    }
    &:disabled {
        padding-bottom: 12px;
    }
`;

const GeotabStyledBulkAssignButton = `
    width: fit-content;
    padding: 12px;
`;

const StyledBulkAssignButton = styled(StyledSubmitButton)`
    ${() => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledBulkAssignButton;
            case 'encompass':
                return EncompassStyledBulkAssignButton;
            default:
                return GeotabStyledBulkAssignButton;
        }
    }};
    text-transform: capitalize;
`;

const EncompassStyledBulkCancelButton = `

`;

const GeotabStyledBulkCancelButton = `
    width: fit-content;
    min-width: fit-content;
`;

const StyledBulkCancelButton = styled(StyledPlainCancelButton)`
    ${() => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledBulkCancelButton;
            case 'encompass':
                return EncompassStyledBulkCancelButton;
            default:
                return GeotabStyledBulkCancelButton;
        }
    }};
    text-transform: capitalize;
    padding: 12px;
`;

export {
    StyledRadio,
    StyledScoreButton,
    StyledSubmitButton,
    StyledCancelButton,
    StyledDialogTitle,
    StyledDialogContent,
    StyledDialogActions,
    StyledConfirmDialogActions,
    StyledPlainSubmitButton,
    StyledPlainCancelButton,
    StyledBulkAssignButton,
    StyledBulkCancelButton,
};
